<div
  class="card-body p-0
    border border-dashed rounded
    overflow-hidden"
  [ngClass]="chartBoxClasses"
>
  <div class="
    flex-grow-1
    px-4 pt-3
    px-sm-6 pt-sm-4
    px-md-4 pt-md-3
    px-lg-6 pt-lg-4
  ">
    <div class="d-flex flex-stack flex-wrap">
      <div class="me-2 w-100">
        <div class="fs-3 fw-bolder">
          <ng-container *ngIf="isTotalNumber; else notNumber">
            <ng-container *ngIf="isCurrency; else notCurrency">
              {{total | appCurrency}}
            </ng-container>
          </ng-container>
          <ng-template #notCurrency>
            <ng-container *ngIf="isPercentage; else numberFormat">
              {{total | percent:'1.0-2':'pl'}}
            </ng-container>
            <ng-template #numberFormat>
              {{total | number:'1.0-2':'pl'}}
            </ng-template>
          </ng-template>
          <ng-template #notNumber>&mdash;</ng-template>
        </div>
        <div
          ngbDropdown
          container="body"
          class="d-inline-block text-muted fs-7 fw-bold text-nowrap"
          (click)="$event.stopPropagation()"
        >
          <div ngbDropdownToggle class="d-flex align-items-center">
            <div class="text-truncate">{{label | translate}}</div>
          </div>
          <div ngbDropdownMenu>
            <button
              *ngFor="let metric of availableMetrics"
              ngbDropdownItem
              (click)="selectMetric.emit(metric.key)"
            >
              {{metric.label | translate}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    #chartRef
    class="mixed-widget-7-chart card-rounded-bottom mt-2 d-block position-relative"
  >
    <apx-chart
      #chart
      [series]="series"
      [chart]="chartOptions.chart"
      [xaxis]="chartOptions.xaxis"
      [yaxis]="chartOptions.yaxis"
      [dataLabels]="chartOptions.dataLabels"
      [stroke]="chartOptions.stroke"
      [legend]="chartOptions.legend"
      [fill]="chartOptions.fill"
      [states]="chartOptions.states"
      [tooltip]="chartOptions.tooltip"
      [colors]="chartOptions.colors"
      [markers]="chartOptions.markers"
      [plotOptions]="chartOptions.plotOptions"
      class="d-block"
    ></apx-chart>
    <div class="pt-2" [ngStyle]="{'backgroundColor': chartBottomColor}"></div>

    <div
      *ngIf="isFakeData"
      class="position-absolute top-0 bottom-0 w-100
        d-flex align-items-center justify-content-center"
    >
      <div
        class="position-absolute top-0 bottom-0 start-0 end-0 opacity-90"
        [ngClass]="chartBoxClasses"
      ></div>
      <div
        class="position-relative fw-bolder text-dark"
      >
        {{'DASHBOARD.LACK_OF_DATA' | translate}}
      </div>
    </div>
  </div>
</div>
